/**
 * @flow
 * @author Box
 */

import { AiLlmEndpointParamsGoogle } from './AiLlmEndpointParamsGoogle';
import { AiLlmEndpointParamsOpenAi } from './AiLlmEndpointParamsOpenAi';

export type AiLlmEndpointParamsGoogleOrAiLlmEndpointParamsOpenAi =
    | AiLlmEndpointParamsGoogle
    | AiLlmEndpointParamsOpenAi;
